module.exports = __webpack_public_path__ + "static/media/bro-r.51a1c936.mp3";